import { MDText } from 'i18n-react';

import { Button, WarningIcon } from '@motorway/mw-highway-code';

import { APIResponseStatus } from 'Services/api.types';

import { useSaleDetailsSub } from '../../hooks/useSaleDetailsSub';

import LocalTexts from './SaleDetailsTexts.json';

import styles from './SaleDetailsError.scss';

const LocalT = new MDText(LocalTexts);

export const SaleDetailsError = () => {
  const { offerStatus, refetchOffer } = useSaleDetailsSub();
  return (
    <div className={styles.saleDetailsError} data-testid="SaleDetailsError">
      <WarningIcon filled={false} />
      <h2 className={styles.title}>{LocalT.translate('title')}</h2>
      <p className={styles.description}>
        {LocalT.translate('description')}
      </p>
      <Button
        disabled={offerStatus === APIResponseStatus.LOADING}
        label={LocalT.translate('buttonText')}
        loading={offerStatus === APIResponseStatus.LOADING}
        onClick={refetchOffer}
        size="medium"
        variant="tertiary"
      />
    </div>
  );
};
